import component from "./RecommendedPlaylistsContainer";
export default component;
